import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { ProductRenewalIntervalInfo } from '../fragments';

export default gql`
  mutation createProductRenewalInterval(
    $input: ProductRenewalIntervalCreateInput!
  ) {
    createProductRenewalInterval(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      productRenewalInterval {
        ...ProductRenewalIntervalInfo
      }
    }
  }
  ${ProductRenewalIntervalInfo}
  ${ErrorMessageInfo}
`;
